// Los atajos del Estudio de Video, como se los explica al usuario —
// ADR-2026-11-03-los-atajos-se-ven.
//
// Sólo los que existen de verdad en el editor: si cambia una tecla en
// `VideoEditor.tsx` (o en `lib/tecladoDeLaTimeline.ts`), cambia acá.

export type Sistema = 'mac' | 'windows';

export type Atajo = {
  que: string;
  /** Las teclas en cada sistema; varias opciones van separadas. */
  mac: string[];
  windows: string[];
};

export const ATAJOS_DEL_ESTUDIO: ReadonlyArray<{ grupo: string; atajos: Atajo[] }> = [
  {
    grupo: 'Reproducir y moverse',
    atajos: [
      { que: 'Reproducir o pausar', mac: ['Espacio'], windows: ['Espacio'] },
      { que: 'Un cuadro atrás o adelante', mac: ['←', '→'], windows: ['←', '→'] },
      { que: 'Un segundo atrás o adelante', mac: ['⇧ ←', '⇧ →'], windows: ['Shift ←', 'Shift →'] },
      { que: 'Ir al principio', mac: ['Fn ←'], windows: ['Inicio'] },
      { que: 'Ir al final', mac: ['Fn →'], windows: ['Fin'] },
      { que: 'Acercar o alejar la timeline', mac: ['⌘ + rueda'], windows: ['Ctrl + rueda'] },
    ],
  },
  {
    grupo: 'Editar',
    atajos: [
      { que: 'Dividir el clip en el cursor', mac: ['S'], windows: ['S'] },
      { que: 'Escribir en un texto del video', mac: ['Doble clic'], windows: ['Doble clic'] },
      { que: 'Borrar el clip', mac: ['⌫'], windows: ['Supr'] },
      { que: 'Deshacer', mac: ['⌘ Z'], windows: ['Ctrl Z'] },
      { que: 'Rehacer', mac: ['⇧ ⌘ Z'], windows: ['Ctrl Y'] },
      { que: 'Salir de un campo de texto', mac: ['Esc'], windows: ['Esc'] },
    ],
  },
];

/** Qué sistema mostrar primero: Mac en un Mac (o iPad), Windows en el resto. */
export function sistemaDelUsuario(nav: { platform?: string; userAgent?: string } | undefined): Sistema {
  const texto = `${nav?.platform ?? ''} ${nav?.userAgent ?? ''}`;
  return /Mac|iPhone|iPad|iPod/i.test(texto) ? 'mac' : 'windows';
}
